import Blog from "./Components/Blog";
import Chosseus from "./Components/Chosseus";
import Helpme from "./Components/Helpme";
import Hero from "./Components/Hero";
import Navbar from "./Components/Navbar";
import Popular from "./Components/Popular";
import Testimonial from "./Components/Testimonial";
import Footer from "./Components/Footer.jsx";
import React from "react";
import { useContext } from "react";
import { CartProvider, useCart } from "react-use-cart";
import { apivalue } from "./Alldata/Data";
import { NavLink } from "react-router";

function Page() {
  const { addItem, totalItems } = useCart();
  const data = useContext(apivalue);

  return (
    <>
    <div className="product-section" id="pro">
            <div className="container">
              <div className="row">
                {/* Start Column 1 */}
                <div className="col-md-12 col-lg-3 mb-5 mb-lg-0">
                  <h2 className="mb-4 section-title">
                    Crafted with excellent material.
                  </h2>
                  <p className="mb-4">
                    Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet
                    velit. Aliquam vulputate velit imperdiet dolor tempor tristique.{" "}
                  </p>
                  <p>
                    <NavLink to="/shop" className="btn">
                      Explore
                    </NavLink>
                  </p>
                </div>
                {/* End Column 1 */}
      {data.map((el) =>
        el.id > 20 ? (
          <div
            className="col-12 col-md-4 col-lg-3 mb-5"
            key={el.id}
            data-aos="fade-up"
          >
            <a className="product-item">
              <img
                src={el.images[0]}
                alt="img"
                className="img-fluid product-thumbnail"
              />
              <h3 className="product-title">{el.title}</h3>
              <strong className="product-price">${el.price}</strong>

              <span className="icon-cross" onClick={() => addItem(el)}>
                <img src="images/cross.svg" alt="img" className="img-fluid" />
              </span>
            </a>
          </div>
        ) : null
      )}
      </div>
        </div>
      </div>
    </>
  );
}
function App() {
  return (
    <CartProvider className="App">
      <Navbar />
      <Hero
        value={
          <h1>
            Modern Interior <span clsas="d-block">Design Studio</span>
          </h1>
        }
      />
       <Page/>
      <Chosseus />
      <Helpme />
      <Popular />
      <Testimonial />
      <Blog />
      <Footer />
     
    </CartProvider>
  );
}

export default App;
